<h1 mat-dialog-title>{{this.dialogData.dialogTitle}}</h1>

 <table border="0" width="100%">
    <tr>
        <td><com-student-panel [student]="this.dialogData.student" [showAttorneyData]="true" [showAge]="true">
        </com-student-panel></td>
        <td style="text-align:center"><img width="150px" src="{{photosUrlService}}/{{this.dialogData.student.id}}" alt="Alumno"></td>
    </tr>
 </table>


<hr>
<div mat-dialog-content>
    <mat-button-toggle-group [(ngModel)]="filterName">
        <mat-button-toggle value="Neg">Negativas</mat-button-toggle>
        <mat-button-toggle value="Pos">Positivas</mat-button-toggle>
        <mat-button-toggle value="Eve">Eventos</mat-button-toggle>
        <mat-button-toggle value="All">Todos</mat-button-toggle>
    </mat-button-toggle-group>

    <ul>
        <li *ngFor="let ele of filterAnnotations(this.dialogData.annotations)">
            <strong>{{ele.createdAt}} - {{ele.annotationType.name}}</strong> : {{ele.text}}
            <br>
            <i>{{ele.creator.fatherSurname}} {{ele.creator.motherSurname}}, {{ele.creator.names}}</i>
        </li>
    </ul>
</div>
<hr>
<div mat-dialog-actions>
    <button mat-raised-button color="primary" [mat-dialog-close]="" cdkFocusInitial>
        <mat-icon>close</mat-icon>&nbsp;Cerrar
    </button>
    <button mat-raised-button matTooltip="Imprimir informe completo" (click)="printReport()" *ngIf="this.dialogData.showPrintSummaryButton">
        <mat-icon>print</mat-icon>&nbsp;Imprimir
    </button>

</div>